const getClientY = (e: MouseEvent | TouchEvent) => 'clientY' in e ? e.clientY : e.touches[0].clientY
const getClientX = (e: MouseEvent | TouchEvent) => 'clientX' in e ? e.clientX : e.touches[0].clientX

export const calculateAxisValues = (
  isVertical: boolean,
  height: number,
  width: number,
): { axisMax: number, scrollAxis: 'x' | 'y', getClientPosition: (e: MouseEvent | TouchEvent) => number } => ({
  axisMax: isVertical ? height : width,
  scrollAxis: isVertical ? 'y' : 'x',
  getClientPosition: (e: MouseEvent | TouchEvent) => (isVertical ? getClientY(e) : getClientX(e)),
})

export const getContentSize = (isVertical: boolean, container: { width: number, height: number }) =>
  isVertical ? container.height : container.width

export const calculateScrollBarDimensions = (
  isVertical: boolean,
  scrollBarWidth: number,
  scrollBarSize: number,
  scrollBarPos: number,
  width: number,
  height: number,
  maxContainerSize: number,
) => ({
  barX: isVertical ? width - scrollBarWidth : scrollBarPos,
  barY: isVertical ? scrollBarPos : height - scrollBarWidth,
  barWidth: isVertical ? scrollBarWidth : scrollBarSize,
  barHeight: isVertical ? scrollBarSize : scrollBarWidth,
  bgX: isVertical ? width - scrollBarWidth : 0,
  bgY: isVertical ? 0 : height - scrollBarWidth,
  bgWidth: isVertical ? scrollBarWidth : maxContainerSize,
  bgHeight: isVertical ? maxContainerSize : scrollBarWidth,
})

export const calculateScrollPercentage = (maxContentSize: number, maxContainerSize: number, currentScroll: number) => {
  return -currentScroll / (maxContentSize - maxContainerSize)
}

export const calculateScrollBarSize = (maxContainerSize: number, maxContentSize: number) => {
  return Math.max((maxContainerSize / maxContentSize) * maxContainerSize, 20)
}
